import React, { useContext } from 'react';
import { AuthContext } from '../../../../../../contexts/AuthContext';
import ButtonTableAction from '../../../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../../../components/default/DefaultDataTable';
import { WarehouseExpedition, WarehouseExpeditionShowDataForm } from '../../../../../../app/models/WareHouseQuoteExpedition';
import { formatMoney } from '../../../../../../utils/utils';

interface Props {
    warehouseQuoteExpeditions: WarehouseExpeditionShowDataForm[];
    totalRows: number;
    isShow?: boolean;
    loading?: boolean;
    edit?: (id: number) => void;
    destroy?: (id: number) => void;
    show?: (id: number) => void;
    filter: any;
    setFilter: (filter: any) => void;
    paginationRowsPerPageOptions?: any[];
}

const WarehouseExpeditionDataTable = ({
    warehouseQuoteExpeditions,
    totalRows,
    loading = false,
    edit,
    destroy,
    show,
    filter,
    setFilter,
    isShow = false,

}: Props) => {
    const { auth } = useContext(AuthContext);

    const columns = [
    
        // {
        //     name: 'Almacén',
        //     selector: (row: any) => row.depot,
        //     sortable: true,
        //     sortField: 'depot',
        //     cell: (row: WarehouseExpedition, index: any, column: any) => (
        //         <span className="">
        //         <div
        //             dangerouslySetInnerHTML={{
        //                 __html: row.origin ? String(row.depot) : ''
        //             }}
        //         />
        //     </span>

        //     )
        // },
                {
            name: 'ID',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: any) => <span>{row.id}</span>
        },

        {
            name: 'Origen',
            selector: (row: any) => row.origin,
            sortable: true,
            sortField: 'origin',
            cell: (row: WarehouseExpeditionShowDataForm, index: any, column: any) => (
                <span>{row.origin}</span>

            )
        },
            {
            name: 'Destino',
            selector: (row: any) => row.destiny,
            sortable: true,
            sortField: 'destiny',
            cell: (row: WarehouseExpeditionShowDataForm, index: any, column: any) => (
                <span>{row.destiny}</span>

            )
        },
        {
            name: 'Tramo',
            selector: (row: WarehouseExpedition) => row.route_segment?.name || '',
            sortable: true,
            sortField: 'route_segment.name',
            cell: (row: WarehouseExpeditionShowDataForm) => <span>{row.route_segment?.name}</span>
        },
        {
            name: 'Contenedor',
            selector: (row: WarehouseExpeditionShowDataForm) => row.packing_type,
            sortable: true,
            sortField: 'packing_type',
            cell: (row: WarehouseExpeditionShowDataForm) => 
            // <span>{row.packing_type?.name}</span>
             (
            <span className="">
                <div
                    dangerouslySetInnerHTML={{
                        __html: row.packing_type ? String(row.packing_type) : ''
                    }}
                />
            </span>
             )
            
        },
    //         {
    //             name: 'Tarifa',
    //             selector: (row: WarehouseExpeditionShowDataForm) => row.rate,
    //             sortable: true,
    //             sortField: 'expedition_rate',
    //             cell: (row: WarehouseExpeditionShowDataForm) => (
    //    <span>
    //   {formatMoney(row.rate ?? 0)} {row.currency} / {row.unit}
    // </span>
    //             )
    //         },
        {
            name: 'Acciones',
            cell: (row: WarehouseExpedition) => (
                <div className="d-flex gap-1">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? 0)}
                            classIcon="mdi mdi-eye"
                            colorIcon="text-info"
                            title="Ver"
                        />
                    )}
                    {!isShow && edit && (
                        <ButtonTableAction
                        callbackFunction={() => edit(row.id ?? -1)}
                        classIcon="mdi mdi-pencil"
                        colorIcon="text-warning"
                        title="Editar"
                        />
                    )}
                    {!isShow && destroy && (
                        <ButtonTableAction
                        callbackFunction={() => destroy(row.id ?? -1)}
                        classIcon="mdi mdi-delete"
                        colorIcon="text-danger"
                        title="Eliminar"
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <div className="row">
            <div className="col-12 mt-4">
                <DefaultDataTable
                    columns={columns}
                    data={warehouseQuoteExpeditions}
                    progressPending={loading}
                    filter={filter}
                    setFilter={setFilter}
                    paginationTotalRows={totalRows}
                />
            </div>
        </div>
    );
};

export default WarehouseExpeditionDataTable;
